import React, {useState} from 'react';
import {Button} from "primereact/button";
import {Dialog} from "primereact/dialog";
import {DataTable} from "primereact/datatable";
import {Column} from "primereact/column";
import { T } from 'services/lang/LanguageService';

type ParametersTableBody = {
    properties: { [key: string]: string };
}

const ParametersTableBody = ({properties}: ParametersTableBody) => {
    if (!properties || (properties && Object.entries(properties).length === 0)) {
        return <></>
    }
    const [dialog, setDialog] = useState(false)


    return <>
        <Button icon="pi pi-bars" className="p-button-sm" onClick={() => setDialog(true)}/>
        <Dialog header={T("word.properties")}
                visible={dialog}
                onHide={() => setDialog(false)}
                style={{minWidth: "20vw"}}
        >
            <DataTable value={Object.entries(properties).map(([key, value]) => {
                return {key: key, value: value}
            })}>
                <Column header={T("word.key")} field="key"/>
                <Column header={T("word.value")} field="value"/>
            </DataTable>
        </Dialog>
    </>
};

export default ParametersTableBody;